import { ScheduleOptions } from './scheduleTypes'

export const validateSchedule = (values: ScheduleOptions) => {
  const errors: Partial<Record<keyof ScheduleOptions, string>> = {}

  return errors
} 